import { deleteRequest, get, post, put } from "../web.request";

export const formAdd = async (data) => {
  return await post(`/createSurveyForm`, data);
}

export const surveyFormList = async (qry) => {
  return await get(`/surveyFormList${qry}`);
}

export const surveyFormDropdown = async () => {
  return await get(`/surveyFormDropdown`);
}

export const formStatusChange = async (id, data) => {
  return await put(`/statusChangeForm/${id}`, data);
}

export const formDelete = async (id) => {
  return await deleteRequest(`/deleteForm/${id}`);
}

export const formDetail = async (id) => {
  return await get(`/surveyFormView/${id}`);
}

export const formUpdate = async (id, data) => {
  return await put(`/updateSurveyForm/${id}`, data);
}

export const formAssign = async (id, data) => {
  return await put(`/formAssign/${id}`, data);
}

export const extendForm = async (id, data) => {
  return await put(`/extendForm/${id}`, data);
}

//copy form
export const copyForm = async (id) => {
  return await get(`/copySurveyForm/${id}`);
}

export const exportForm = async (id) => {
  return await post(`/submittedFormDownload/${id}`);
}

export const exportFormV2 = async (id, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return await post(`/submittedFormExportV2/${id}${query ? `?${query}` : ''}`, {});
}

export const exportFormExcel = async (id) => {
  try {
    const { axiosInstance } = await import("../helper/AxiosInstance");
    const response = await axiosInstance.post(`/submittedFormExportExcel/${id}`, {}, {
      responseType: 'blob',
    });
    return {
      status: true,
      data: response.data,
    };
  } catch (error) {
    let message = "Something went wrong";
    if (error?.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        if (json?.message) message = json.message;
      } catch (e) {}
    } else if (error?.response?.data?.message) {
      message = error.response.data.message;
    }
    return {
      status: false,
      message,
    };
  }
}

//privew form
export const previewForm = async (id) => {
  return await put(`/updateIsPreview/${id}`);
}